import type { ReactNode } from 'react';
import { usePageAccess } from '@/hooks/usePageAccess';

type PageAction = 'create' | 'edit' | 'delete';

interface PageActionGateProps {
  action: PageAction;
  children: ReactNode;
  /** Optional path override when gating actions for a different route */
  path?: string;
  fallback?: ReactNode;
}

export function PageActionGate({ action, children, path, fallback = null }: PageActionGateProps) {
  const access = usePageAccess(path);
  const allowed =
    action === 'create' ? access.canCreate : action === 'edit' ? access.canEdit : access.canDelete;
  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
}
